import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * SE.AGENCY logo. Uses the real wordmark asset — the dark-ink variant on
 * light surfaces (tone="dark"), the white variant on dark surfaces
 * (tone="light"). Height is driven by `size`.
 */
@Component({
  selector: 'se-logo',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <img
      [src]="tone === 'light' ? '/S.E_WHITE_LOGO.png' : '/S.E_DARK_LOGO.png'"
      alt="SE.AGENCY"
      [style.height]="size"
      class="w-auto select-none"
      draggable="false"
    />
  `,
})
export class LogoComponent {
  /** 'dark' ink for light surfaces, 'light' (white) for dark surfaces. */
  @Input() tone: 'dark' | 'light' = 'dark';
  /** CSS height of the logo image. */
  @Input() size = '1.5rem';
}
